// Copyright (c) 2016 Deere & Company

import actions from '../actions-list';

export const resetCkcCustomerFailure = () => ({
    type: actions.RESET_CKC_CUSTOMER_FAILURE
});



// WEBPACK FOOTER //
// ./src/shared/action-creators/customer-failed.js